module.exports = __webpack_public_path__ + "img/face-recognition-famale.f1559246.png";